import React, { useState } from 'react'
import { Col } from 'reactstrap';
import { Nav, Tab } from "react-bootstrap";
import taskIcon from "../../../images/task-icon-selected.svg";
import taskInactiveIcon from "../../../images/task-icon.svg";
import historyIcon from "../../../images/history.svg";
import historyInactiveIcon from "../../../images/history-gray.svg";
// import "../../PortalPage/ManualTodos/manualTodos.scss";
import { ViewTabs } from '../../Widgets/Todos/ManualTodos/TodoViewDetails';
import { 
  CaseNotificationsEnum,
  CasePrePostEnum,
  ICaseDetailsModel,
  ICaseTaskDetailsList,
  ICaseTaskHistoryModel, 
  ICaseTaskModel, 
  ICaseTaskNotificationModel, 
  TaskStatusEnum 
} from '../../../models/Cases/CaseDetailsModel';
import "./caseTasks.scss"
import { catchError } from '../../../utils/Utils';
import CaseTaskHistory from './CaseTaskHistory';
import TaskDetails from './TaskDetails';
import Service from '../../../services';

interface ITaskTabsProps {
  task: ICaseTaskModel | null;
  toggleCaseTaskModal: () => void;
  selectedTask: ICaseTaskModel | null;
  getCaseTaskByTaskId: (id: string) => void;
  caseDetails: ICaseDetailsModel | null;
  verifyTask: (values: any, init?: boolean) => Promise<void>
}

const TaskTabs = (props: ITaskTabsProps) => {
  const service = new Service();
  const { 
    task, 
    selectedTask, 
    toggleCaseTaskModal,
    getCaseTaskByTaskId,
    caseDetails,
    verifyTask
  } = props;
  const [viewTab, setViewTab] = useState(ViewTabs.TaskDetailsTab);
  const [taskHistory, setTaskHistory] = useState<ICaseTaskHistoryModel[]>([])

  const getTaskHistorybyTaskId = (id: string) => {
    service.getTaskHistorybyTaskId(id)
      .then((res:any) => {
        setTaskHistory(res?.data);
      })
      .catch((err:any) => catchError(err, true))
  }

  const editTask = () => {
    toggleCaseTaskModal();
    const payload = {
      caseId: caseDetails?.caseId,
      title: selectedTask?.title,
      assignedTo: selectedTask?.assignedTo,
      description: selectedTask?.description,
      predecessorTo: selectedTask?.casePrePostTaskDetailsList
        ?.filter(each => each?.type === CasePrePostEnum.PREDECESSOR)
        .map((item: ICaseTaskDetailsList) => {
          return { text: item?.title, value: item?.taskId };
        }),
      successorTo: selectedTask?.casePrePostTaskDetailsList
        ?.filter(each => each?.type === CasePrePostEnum.SUCCESSOR)
        .map((item: ICaseTaskDetailsList) => {
          return { text: item?.title, value: item?.taskId };
        }),
      dueDate: selectedTask?.dueDate,
      reachingDueDateNotificatonId:  
        props?.selectedTask?.caseNotifications
        ?.filter(each => each?.type === CaseNotificationsEnum.DUE)
        .map((item: ICaseTaskNotificationModel) => {
          return { text: item?.userName, value: item?.userId };
        }),
      completionNotificationId: 
        props?.selectedTask?.caseNotifications
        ?.filter(each => each?.type === CaseNotificationsEnum.COMPLETION)
        .map((item: ICaseTaskNotificationModel) => {
          return { text: item?.userName, value: item?.userId };
        }),
      taskId: selectedTask?.taskId,
      type: selectedTask?.type
    }
    verifyTask(payload, true)
  }

  return (
    <div className="todoViewDetailsBody">
      <Tab.Container defaultActiveKey={ViewTabs.TaskDetailsTab} >
        <Col className="navLinksSearch">
          <Nav variant="tabs" >
            <Nav.Item>
              <Nav.Link 
                eventKey={ViewTabs.TaskDetailsTab} 
                onClick={() => {
                  setViewTab(ViewTabs.TaskDetailsTab)
                  task && getCaseTaskByTaskId(task?.taskId)
                }}
              >
                { viewTab === ViewTabs.TaskDetailsTab ? 
                    <img src={taskIcon} /> :
                    <img src={taskInactiveIcon} />
                } Task Details
              </Nav.Link>{" "}
            </Nav.Item>
            <Nav.Item >
              <Nav.Link eventKey={ViewTabs.TaskHistoryTab} 
                onClick={() => {
                  setViewTab(ViewTabs.TaskHistoryTab);
                  task && getTaskHistorybyTaskId(task?.taskId);
                }}
              >
                { 
                  viewTab === ViewTabs.TaskHistoryTab ? 
                    <img src={historyIcon} /> :
                    <img src={historyInactiveIcon} />
                } Task History
              </Nav.Link>{" "}
            </Nav.Item>
          </Nav>
          { task?.status === TaskStatusEnum.COMPLETED || 
            caseDetails?.status === "READY_FOR_REVIEW" ? <></> : 
            <button className="createTaskButton" onClick={editTask}>
              Edit Task
            </button>
          }
        </Col>
        <Col>
          <Tab.Content>
            <Tab.Pane eventKey={ViewTabs.TaskDetailsTab}>
              <TaskDetails task={selectedTask} />
            </Tab.Pane>
            <Tab.Pane eventKey={ViewTabs.TaskHistoryTab}>
              <CaseTaskHistory taskHistory={taskHistory} />
            </Tab.Pane>
          </Tab.Content>
        </Col>
      </Tab.Container>
    </div>
  )
}

export default TaskTabs